__turbopack_context__.v({
  "notif": "ShareButton-module__mE_G0W__notif",
  "show": "ShareButton-module__mE_G0W__show",
});
